<script setup lang="ts">
    import { PhWarningDiamond, PhX, PhCheckCircle } from '@phosphor-icons/vue';
    import { useToast } from '@/helper/toast.js';

    const { toasts, hide } = useToast();

    const closeToast = (toastId: number) => {
        hide(toastId);
    };
</script>

<template>
    <div class="fixed top-14 right-11 z-9999">
        <TransitionGroup
            enter-active-class="transition-all ease-out duration-200"
            enter-from-class="transform translate-x-full opacity-0 scale-95"
            enter-to-class="transform translate-x-0 opacity-100 scale-100"
            leave-active-class="transition-all ease-in duration-150"
            leave-from-class="transform translate-x-0 opacity-100 scale-100"
            leave-to-class="transform translate-x-full opacity-0 scale-95"
            move-class="transition-all duration-300 ease-out"
        >
            <div
                v-for="(toast, index) in toasts"
                :key="toast.id"
                class="bg-white rounded-xl flex items-stretch h-auto min-h-[60px]"
                :style="{
                    boxShadow:
                        '0px 4px 8px 0px rgba(0, 0, 0, 0.3), 0px 12px 24px 0px rgba(0, 0, 0, 0.2)',
                    marginBottom: index === toasts.length - 1 ? '0' : '12px'
                }"
                role="alert"
            >
                <div
                    class="flex items-center px-3 rounded-l-xl min-h-full"
                    :class="{
                        'bg-error-100': toast.type === 'error',
                        'bg-[#E8F5EA]': toast.type === 'success'
                    }"
                >
                    <PhWarningDiamond
                        v-if="toast.type === 'error'"
                        :size="28"
                        weight="fill"
                        class="text-error-500"
                    />
                    <PhCheckCircle
                        v-else-if="toast.type === 'success'"
                        :size="28"
                        weight="fill"
                        class="text-success-500"
                    />
                </div>

                <template v-if="toast.title">
                    <div class="flex flex-col gap-1 p-3">
                        <div class="flex flex-row justify-between items-start">
                            <b class="max-w-xs text-base text-neutral-800">{{ toast.title }}</b>
                            <PhX
                                :size="22"
                                @click.stop="closeToast(toast.id)"
                                class="cursor-pointer text-neutral-800"
                            />
                        </div>
                        <p class="w-80 text-base text-neutral-800" v-html="toast.message"></p>
                        <div class="justify-end flex" v-if="toast.button">
                            <b
                                class="text-error-500 px-4 cursor-pointer"
                                @click.stop="closeToast(toast.id)"
                                >Got it</b
                            >
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="flex flex-row items-start gap-3 p-3">
                        <p class="max-w-xs text-base text-neutral-800" v-html="toast.message"></p>
                        <PhX
                            :size="22"
                            @click.stop="closeToast(toast.id)"
                            class="cursor-pointer text-neutral-800"
                        />
                        <div class="justify-end flex" v-if="toast.button">
                            <b
                                class="text-error-500 px-4 cursor-pointer"
                                @click.stop="closeToast(toast.id)"
                                >Got it</b
                            >
                        </div>
                    </div>
                </template>
            </div>
        </TransitionGroup>
    </div>
</template>
